import React, { useState } from "react"
import { slice, concat } from "lodash"
import { useMediaQuery } from "react-responsive"
import {
  MainContainer,
  Heading,
  HeadingContainer,
  InnerContainer,
  Track,
  Loadmore,
  ModalContainer,
  ScrollContainer,
  SubmitButton,
  ButtonsContainer,
  GradientHeading,
} from "./sessionstyles"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"
import { CgCloseO } from "react-icons/cg"
import "./modal.css"
import { AboutSubheading } from "../AboutSection/aboutStyles"
import Fade from "react-reveal/Fade"

const DATA = [
  "React state management",
  "GraphQL",
  "React TypeScript",
  "Mobx",
  "Mobx-state-tree",
  "Micro-frontend",
  "Server-Side Rendering",
  "Design System",
  "React Hooks",
  "Jest unit testing",
  "Design patterns",
  "SPAs & React Web Apps",
  "Prop Validation",
  "Testing components",
]

const ScientificSessions = () => {
  const isMobile = useMediaQuery({
    query: "(max-device-width: 814px)",
  })

  const LIMIT = isMobile ? 4 : 9
  const [showMore, setShowMore] = useState("View More")
  const [list, setList] = useState(slice(DATA, 0, LIMIT))
  const [isModalVisible, setModalVisible] = useState(false)
  const [modalHeading, setModalHeading] = useState(" ")

  const loadMore = () => {
    const newList = DATA

    setList(newList)
    setShowMore("View Less")
  }

  const viewLess = () => {
    const newList = slice(DATA, 0, LIMIT)
    setList(newList)
    setShowMore("View More")
    const elmnt = document.getElementById("main")
    elmnt.scrollIntoView()
  }

  const isgalaxy = useMediaQuery({
    query: "(max-device-width: 365px)",
  })
  const isIphone = useMediaQuery({
    query: "(max-device-width: 325px)",
  })

  const bg = {
    overlay: { background: "rgba(0,0,0,0.4);" },
    modal: {
      width: isMobile ? (isgalaxy ? "86%" : "85.3%") : "894px",

      padding: isIphone ? "53px 19px" : "53px 37px",
      background: "linear-gradient(to right, #4f3ec8 0%,  #8656f3 100%)",
      // background:'#fff',
      borderRadius: isMobile ? "16px" : "14px",
      height: "max-content",

      boxShadow: "0 12px 15px 0 rgba(0, 0, 0, 0.25)",
      margin: "49px auto",
    },
  }

  const scroll = () => {}

  return (
    <>
      <MainContainer id="main">
        <HeadingContainer>
          <Heading>TOPICS</Heading>
        </HeadingContainer>
        <InnerContainer>
          {list.map(node => (
            <Fade up>
              <Track
                onClick={() => {
                  setModalVisible(true)
                  setModalHeading(node)
                }}
              >
                {node}
              </Track>
            </Fade>
          ))}
        </InnerContainer>
        {showMore && (
          <Loadmore
            className="hvr-grow"
            onClick={showMore === "View More" ? loadMore : viewLess}
          >
            {showMore === "View More" ? "View More" : "View Less"}
          </Loadmore>
        )}
        <Modal
          open={isModalVisible}
          onClose={() => setModalVisible(false)}
          styles={bg}
          closeIcon={<CgCloseO size="2rem" color="#fff" />}
          center
        >
          <ModalContainer>
            <Fade up>
              <Heading
                style={{
                  color: "#fff",
                  textAlign: "left",
                  fontSize: isIphone ? "21px" : "25px",
                  marginBottom: "10px",
                  lineHeight: "30px",
                }}
              >
                {modalHeading}
              </Heading>
            </Fade>
            <Fade up>
              <ScrollContainer>
                <AboutSubheading style={{ marginTop: "0px", color: "#fff" }}>
                  React state management GraphQL React TypeScript Mobx and
                  mobx-state-tree Micro-frontend Server-Side Rendering Design
                  System Creating / Working with Hooks React Jest unit testing
                  General design patterns Real-World SPAs & React Web Apps React
                  Alternatives Class components, Defining and rendering a
                  component Prop Validation Testing components React state
                  management GraphQL React TypeScript Mobx and mobx-state-tree
                  Micro-frontend Server-Side Rendering Design System Creating /
                  Working with Hooks React Jest unit testing General design
                  patterns Real-World SPAs & React Web Apps React Alternatives
                  Class components, Defining and rendering a component Prop
                  Validation Testing components
                </AboutSubheading>
              </ScrollContainer>
            </Fade>
            <Fade up>
              <ButtonsContainer>
                <SubmitButton>Submit Abstract</SubmitButton>
                <SubmitButton>Request new topic</SubmitButton>
              </ButtonsContainer>
            </Fade>
          </ModalContainer>
        </Modal>
      </MainContainer>
    </>
  )
}

export default ScientificSessions
